import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.function.name.js";
import serverList from "../../../components/serverList/serverOptions.vue";
export default {
  name: "compSearchBox",
  components: {
    serverList: serverList
  },
  props: {
    loginTimedata: Array,
    payInfoData: Object,
    coinInfoData: Object,
    stageInfoData: Object,
    taskInfoData: Object,
    activeName: String
  },
  data: function data() {
    return {
      searchInfo: {},
      //玩家信息（没有时间）
      searchRoleInfoList: {},
      //角色登录日志有时间
      searchRoleLoginList: {},
      //充值日志有时间和订单状态
      searchPayList: {},
      //货币日志有时间
      searchCoinList: {},
      //道具日志有时间
      searchStageList: {},
      //任务日志有时间
      searchTaskList: {}
    };
  },
  created: function created() {
    if (this.$route.query) {
      var k = JSON.stringify(this.$route.query) == "{}";
      if (k == true) {
        this.$set(this.searchInfo, "roleId", window.localStorage.getItem("roleId"));
        this.searchEvent();
      } else {
        this.$set(this.searchInfo, "roleId", this.$route.query.roleId);
        this.searchEvent();
      }
    } else {
      this.$set(this.searchInfo, "roleId", window.localStorage.getItem("roleId"));
      this.searchEvent();
    }
  },
  watch: {
    activeName: function activeName() {
      this.searchEvent();
    },
    $route: function $route(newVal) {
      if (this.$router.name == "userRoleInfo") {
        if (newVal.query) {
          var k = JSON.stringify(newVal.query) == "{}";
          if (k == true) {
            this.$set(this.searchInfo, "roleId", window.localStorage.getItem("roleId"));
            this.searchEvent();
          } else {
            this.$set(this.searchInfo, "roleId", this.$route.query.roleId);
            this.searchEvent();
          }
        } else {
          this.$set(this.searchInfo, "roleId", window.localStorage.getItem("roleId"));
          this.searchEvent();
        }
      }
    }
  },
  methods: {
    searchEvent: function searchEvent() {
      if (this.activeName == "roleMsg") {
        //玩家信息
        this.searchRoleInfoList.roleId = this.searchInfo.roleId;
        this.searchRoleInfoList.roleName = this.searchInfo.roleName;
        this.searchRoleInfoList.server_id = this.searchInfo.server_id;
        this.$emit("compBtnSearch", this.searchRoleInfoList);
      } else if (this.activeName == "loginMsg") {
        //角色登录日志
        this.searchRoleLoginList.sdate = this.loginTimedata[0];
        this.searchRoleLoginList.edate = this.loginTimedata[1];
        this.searchRoleLoginList.roleId = this.searchInfo.roleId;
        this.searchRoleLoginList.roleName = this.searchInfo.roleName;
        this.searchRoleLoginList.server_id = this.searchInfo.server_id;
        this.$emit("compBtnSearch", this.searchRoleLoginList);
      } else if (this.activeName == "payMsg") {
        //充值日志
        this.searchPayList.sdate = this.payInfoData.payTimedata[0];
        this.searchPayList.edate = this.payInfoData.payTimedata[1];
        this.searchPayList.cp_orderno = this.payInfoData.cp_orderno;
        this.searchPayList.platform_orderno = this.payInfoData.platform_orderno;
        this.searchPayList.status = this.payInfoData.status;
        this.searchPayList.roleId = this.searchInfo.roleId;
        this.searchPayList.roleName = this.searchInfo.roleName;
        this.searchPayList.server_id = this.searchInfo.server_id;
        this.$emit("compBtnSearch", this.searchPayList);
      } else if (this.activeName == "coinMsg") {
        //货币日志
        this.searchCoinList.sdate = this.coinInfoData.coinTimedata[0];
        this.searchCoinList.edate = this.coinInfoData.coinTimedata[1];
        this.searchCoinList.changeType = this.coinInfoData.changeType;
        this.searchCoinList.coin_type = this.coinInfoData.coin_type;
        this.searchCoinList.roleId = this.searchInfo.roleId;
        this.searchCoinList.roleName = this.searchInfo.roleName;
        this.searchCoinList.server_id = this.searchInfo.server_id;
        this.$emit("compBtnSearch", this.searchCoinList);
      } else if (this.activeName == "stageMsg") {
        //道具日志
        this.searchStageList.goods_id = this.stageInfoData.goods_id;
        this.searchStageList.sdate = this.stageInfoData.stageTimedata[0];
        this.searchStageList.edate = this.stageInfoData.stageTimedata[1];
        this.searchStageList.roleId = this.searchInfo.roleId;
        this.searchStageList.roleName = this.searchInfo.roleName;
        this.searchStageList.server_id = this.searchInfo.server_id;
        this.$emit("compBtnSearch", this.searchStageList);
      } else if (this.activeName == "taskMsg") {
        this.searchTaskList.sdate = this.taskInfoData.taskTimedata[0];
        this.searchTaskList.edate = this.taskInfoData.taskTimedata[1];
        this.searchTaskList.task_id = this.taskInfoData.task_id;
        this.searchTaskList.roleId = this.searchInfo.roleId;
        this.searchTaskList.roleName = this.searchInfo.roleName;
        this.searchTaskList.server_id = this.searchInfo.server_id;
        this.$emit("compBtnSearch", this.searchTaskList);
      }
    }
  }
};